import { createBreakPoints } from './helpers';

const labels = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const breakpoints = ['0px', '20rem', '40rem', '64rem', '80rem', '100rem'];

export const mediaQueries = createBreakPoints(labels, breakpoints);
const cssMediaQueries = createBreakPoints(labels, breakpoints, true);

//USING THIS TO HAVE REM LIKE MANAGMENT OF HEADER-SIZES WHICH OFTEN HAVE A DIFFERENT FONT
const remCalc = function(size) {
  if (isNaN(size)) {
    size = parseInt(size);
  }
  return size / typography.size.replace('px', '') + 'rem';
};

//COLORS VARIABLES
const colors = {
  white: '#FFF',
  black: '#111',
  red: '#E82A2A',
  green: '#69a24c',
  yellow: '#FFC762',
  font: '#222',
  primary: '#789573',
  primaryLight: '#D1DEC8',
  primaryDark: '#2E5143',
  secondary: '#FFC762',
  secondaryLight: '#FFC762',
  secondaryDark: '#FFC762',
  discount: '#b44e3c',
  link: '#ce3c8a',
  border: '#DDD',
  borderLight: '#F1F1F1',
  borderDark: '#333',
  borderInput: '#AAA',
  lightgrey: '#f6f6f6',
  vanillaWhite: '#fbf8f4',
  grey: '#565558',
  error: '#ff3131',
  success: '#69a24c',
  greys: [
    '#F9F9F9',
    '#F1F1F1',
    '#D5D5D5',
    '#C4C4C4',
    '#9A9A9A',
    '#777777',
    '#3B3B3B'
  ]
};
colors.buy = colors.primary;
colors.backgroundLight = colors.primaryLight;
colors.backgroundDark = colors.primaryDark;
colors.inStock = '#339600';
colors.outOfStock = colors.red;

//FONTS
const font = {
  primary: 'montserrat',
  secondary: 'charlotte'
};

const weights = {
  ultra: 100,
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
};

//TYPOGRAPHY
let typography = {
  fontFamily: font.primary,
  fontWeight: weights.normal,
  size: '14px',
  letterSpacing: '0',
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.7em',
    marginBottom: '1rem'
  },
  header: {
    fontFamily: font.primary,
    textTransform: 'none',
    fontWeight: weights.bold,
    letterSpacing: '0',
    secondFont: {
      fontFamily: font.secondary,
      fontWeight: weights.normal
    },
    secondColor: {
      color: colors.primaryDark
    }
  }
};

//HEADER FONTSIZES h1-h5 (sm & md & lg & xl)
typography.header.fontSize = [
  '__',
  [remCalc(22), remCalc(26), remCalc(28), remCalc(32)],
  [remCalc(20), remCalc(22), remCalc(24), remCalc(26)],
  [remCalc(16), remCalc(16), remCalc(18), remCalc(20)],
  [remCalc(14), remCalc(14), remCalc(16), remCalc(17)],
  [remCalc(12), remCalc(12), remCalc(12), remCalc(14)]
];

const general = {
  maxWidth: '1600px',
  maxWidthText: '1000px',
  pagePadding: {
    lg: '1rem',
    md: '1rem',
    sm: '1rem'
  },
  hallmarkBorder: '2px solid ' + colors.borderDark,
  radius: '3px',
  boxShadow: '0px 1px 2px #0000000d',
  hideCategory: true,
  hideProduct: true
};

//BUTTON
const button = {
  background: colors.primary,
  backgroundSecondary: colors.primaryDark,
  color: colors.white,
  colorSecondary: colors.primaryLight,
  fontFamily: font.primary,
  fontWeight: weights.bold,
  fontSize: ['0.9rem', '0.9rem', '1rem', '1rem'],
  ListFontSize: ['0.7rem', '0.8rem', '0.8rem', '0.8rem'],
  textTransform: 'uppercase',
  letterSpacing: '1px'
};

//AREAS

//TOPBAR
const topBar = {
  height: {
    lg: 36,
    md: 36,
    sm: 36,
    scroll: 0
  },
  color: colors.primaryLight,
  background: colors.primaryDark,
  fontSize: '0.8rem',
  fontWeight: weights.normal,
  usp: {
    fontSize: '0.8rem',
    fontWeight: weights.normal
  }
};

//DESKTOP HEADER
const desktopHeader = {
  height: {
    lg: 90,
    md: 90,
    scroll: 70
  },
  search: {
    height: {
      lg: 30,
      md: 30
    }
  },
  logo: {
    height: {
      lg: 50,
      md: 50,
      scroll: 50
    }
  },
  nav: {
    fontSize: [remCalc(14), remCalc(16)],
    fontWeight: weights.normal,
    fontFamily: typography.header.fontFamily,
    padding: '0.8rem',
    barHoverColor: colors.buy,
    subMenu: {
      lv2: {
        fontSize: '1.1rem'
      },
      lv3: {
        fontSize: '0.9rem'
      }
    },
    height: {
      lg: 90,
      md: 90,
      scroll: 70
    },
    useSubMenuImage: true
  }
};

//MOBILE HEADER
const mobileHeader = {
  height: {
    xs: 60,
    sm: 60,
    scroll: 60
  },
  search: {
    height: {
      xs: 60,
      sm: 60
    }
  },
  logo: {
    height: 36
  },
  nav: {
    padding: '30px',
    lv1: {
      fontSize: remCalc(17),
      fontWeight: typography.header.fontWeight,
      fontFamily: typography.header.fontFamily,
      lineHeight: '2.4em',
      textTransform: 'none'
    },
    lv2: {
      fontSize: '1rem',
      lineHeight: '2.6em'
    },
    lv3: {
      fontSize: '0.9rem',
      lineHeight: '2.6em'
    },
    activeColor: colors.primaryDark,
    selectedColor: colors.primary
  }
};

//HEADER HEIGHTS
const header = {
  height: {
    lg: topBar.height.lg + desktopHeader.height.lg,
    md: topBar.height.md + desktopHeader.height.md,
    sm: topBar.height.md + mobileHeader.height.sm,
    xs: topBar.height.md + mobileHeader.height.xs,
    scroll: topBar.height.scroll + desktopHeader.height.scroll
  },
  scrollBreak: 50
};

//FOOTER
const footer = {
  background: colors.primaryLight,
  color: colors.primaryDark,
  logoWrapper: {
    background: colors.white
  }
};

//START PAGE
const startPage = {
  headers: {
    textTransform: 'none',
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight,
    fontSize: [
      '__',
      [remCalc(26), remCalc(36), remCalc(46), remCalc(74)],
      [remCalc(22), remCalc(30), remCalc(36), remCalc(46)],
      typography.header.fontSize[2],
      typography.header.fontSize[3],
      typography.header.fontSize[4]
    ]
  },
  iconBar: {
    background: colors.primaryDark,
    color: colors.white
  },
  textBox: {
    background: colors.primary,
    color: colors.white
  },
  row: {
    background: {
      primary: colors.backgroundLight,
      secondary: colors.backgroundDark
    },
    color: {
      primary: colors.primaryDark,
      secondary: colors.primaryLight
    }
  },
  readMore: {
    color: colors.font,
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight
  },
  cta: {
    fontSize: button.fontSize,
    color: colors.primaryLight,
    background: colors.primaryDark,
    border: 'none',
    fontFamily: button.fontFamily,
    fontWeight: weights.bold,
    textTransform: button.textTransform,
    letterSpacing: button.letterSpacing,
    hover: {
      color: colors.primaryDark,
      background: colors.primaryLight,
      border: 'none'
    },
    secondary: {
      color: colors.primaryDark,
      background: colors.primaryLight,
      border: 'none',
      hover: {
        color: colors.primaryLight,
        background: colors.primaryDark,
        border: 'none'
      }
    },
    third: {
      color: colors.white,
      background: 'transparent',
      border: '4px solid' + colors.primary,
      hover: {
        color: colors.white,
        background: colors.primary,
        border: '4px solid' + colors.primary
      }
    }
  }
};

//CATEGORY PAGE
const categoryPage = {
  subcategories: {
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight
  },
  filter: {
    markerColor: colors.buy,
    hoverColor: colors.buy,
    desktop: {
      titles: {
        fontSize: '1rem',
        fontWeight: weights.medium
      }
    }
  }
};
//PRODUCT GRID
const productGrid = {
  col: {
    sm: 2,
    md: 3,
    lg: 4,
    xl: 4
  },
  space: {
    sm: 2,
    md: 2,
    lg: 2,
    xl: 2
  },
  product: {
    padding: {
      sm: '0',
      md: '0',
      lg: '0'
    },
    imageAspect: '4:3',
    background: '#FFF',
    border: 'none',
    name: {
      fontFamily: typography.header.fontFamily,
      fontWeight: weights.medium
    }
  }
};

const price = {
  fontFamily: typography.header.fontFamily,
  fontWeight: weights.medium,
  normal: {
    color: colors.font,
    fontSize: typography.header.fontSize[4]
  },
  new: {
    color: colors.discount,
    fontSize: typography.header.fontSize[4]
  },
  old: {
    color: colors.greys[5],
    fontSize: typography.header.fontSize[5],
    fontWeight: weights.normal
  }
};

//PRODUCT PAGE
const productPage = {
  name: {
    fontFamily: productGrid.product.name.fontFamily,
    fontWeight: productGrid.product.name.fontWeight
  },
  price: {
    normal: {
      fontSize: typography.header.fontSize[2][3]
    },
    new: {
      fontSize: typography.header.fontSize[2][3]
    },
    old: {
      fontSize: typography.header.fontSize[3][3]
    }
  },
  imageAspect: '1:1',
  buyButton: {
    background: colors.buy,
    color: colors.white
  },
  tabs: {
    barActiveColor: colors.primaryLight,
    header: {
      fontFamily: typography.header.fontFamily,
      fontWeight: typography.header.fontWeight
    }
  },
  productList: {
    headerColor: colors.font,
    subHeaderColor: colors.primary
  }
};

export const theme = {
  ...cssMediaQueries,
  font,
  weights,
  typography,
  colors,
  general,
  button,
  topBar,
  desktopHeader,
  mobileHeader,
  header,
  footer,
  startPage,
  categoryPage,
  productGrid,
  price,
  productPage
};
